"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var chroma_js_1 = __importDefault(require("chroma-js"));
var readableColor = function (textDefault, textAlt) { return function (hex, darkColor, lightColor) {
    /**
     * Returns `textDefault` or `textAlt` (or optional light and dark return colors) for best contrast depending on the luminosity of the given color. Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
     *
     * @param {string} color - any string that represents a color (ex: "#f00" or "rgb(255, 0, 0)")
     * @param {string} darkColor - defaults to theme's darkest gray
     * @param {string} lightColor - defaults to theme's lightest gray
     */
    if (darkColor === void 0) { darkColor = textDefault; }
    if (lightColor === void 0) { lightColor = textAlt; }
    if (hex === 'transparent') {
        return hex;
    }
    var luminanceRatio = 0.179;
    return (0, chroma_js_1.default)(hex).luminance() < luminanceRatio ? lightColor : darkColor;
}; };
exports.default = readableColor;
